// src/components/MapHoverCard.jsx
import { Box, Text, VStack, Button, IconButton } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";

const MotionBox = motion(Box);

export default function MapHoverCard({
  sector,
  onViewFlyer,
  isMobile,
  isBusiness,
  onClose,
}) {
  if (!sector || isMobile) return null;

  const households =
    sector.households ??
    sector.household_count ??
    sector.householdCount ??
    null;

  const booked =
    sector.bookedSlots ??
    sector.slots_available ??
    sector.slotsAvailable ??
    null;

  const roi =
    isBusiness
      ? sector.roi ??
        sector.roi_estimate ??
        sector.predicted_roi ??
        null
      : null;

  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const padding = 12;

  let screenX = Math.max(padding, Math.min(vw - padding, sector.screenX ?? 0));
  let screenY = Math.max(padding, Math.min(vh - padding, sector.screenY ?? 0));

  return (
    <AnimatePresence>
      <MotionBox
        key={sector.name}
        className="map-hover-card"
        position="absolute"
        top={`${screenY}px`}
        left={`${screenX}px`}
        transform="translate(-50%, -100%)"
        bg="white"
        borderRadius="md"
        shadow="md"
        px={3}
        py={2}
        minW="160px"
        border="1px solid rgba(0,0,0,0.08)"
        style={{
          zIndex: 999999,        // ⭐ Always above Leaflet
          pointerEvents: "auto", // ⭐ Card is clickable
        }}
        initial={{ opacity: 0, y: -6, scale: 0.95 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: -6, scale: 0.95 }}
        transition={{ duration: 0.15, ease: "easeOut" }}
        onClick={(e) => e.stopPropagation()} // ⭐ Prevent closing when clicking card
      >
        <IconButton
          aria-label="Close"
          size="xs"
          variant="ghost"
          position="absolute"
          top="2px"
          right="2px"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          ✕
        </IconButton>

        <VStack align="flex-start" spacing={1}>
          <Text fontSize="sm" fontWeight="bold" color="red.600">
            {sector.name}
          </Text>

          <Text fontSize="xs" color="gray.700">
            🏠 {households ? households.toLocaleString() : "No household data"}
          </Text>

          <Text fontSize="xs" color="gray.700">
            🎟️ {booked != null ? booked : "No slot data"}
          </Text>

          {roi && (
            <Text fontSize="xs" color="gray.700">
              💰 ROI: {roi}
            </Text>
          )}

          <Button
            mt={1}
            size="xs"
            colorScheme="red"
            width="100%"
            onClick={(e) => {
              e.stopPropagation();
              onViewFlyer();
            }}
          >
            View Coupons →
          </Button>
        </VStack>
      </MotionBox>
    </AnimatePresence>
  );
}
